import { VolumeSet } from "../../schema/types/volumeSet/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const STORAGE_KEY_VOLUMESET_LIST_LIMIT_TO_CONTEXT_GVC = "STORAGE_KEY_VOLUMESET_LIST_LIMIT_TO_CONTEXT_GVC";

export interface VolumeSetTableItem extends VolumeSet {
  selfLink: string;
}

interface GetVolumeSetTableItemProps {
  link?: string;
  name?: string;
  item?: VolumeSet;
}
export function getVolumeSetTableItem({ link, name, item }: GetVolumeSetTableItemProps): VolumeSetTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "volumeset",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      spec: { fileSystemType: "ext4", initialCapacity: 20 },
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "volumeset",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    spec: { fileSystemType: "ext4", initialCapacity: 20 },
    lastModified: "",
    tags: {},
    version: 1,
  };
}
